module.exports = __webpack_public_path__ + "img/obi.603b15e.svg";